import DiscoverGaia from './DiscoverGaia'

export default DiscoverGaia
// eslint-disable-next-line import/export
export * from './DiscoverGaia'
